import * as React from "react";
import Svg, { Path } from "react-native-svg";

export function StarIcon(props: any) {
  return (
    <Svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      {...props}
    >
      <Path
        d="M5.0026 1L6.2901 3.60833L9.16927 4.02917L7.08594 6.05833L7.5776 8.925L5.0026 7.57083L2.4276 8.925L2.91927 6.05833L0.835938 4.02917L3.7151 3.60833L5.0026 1Z"
        fill="#251F2C"
        stroke="#251F2C"
        stroke-width="0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Svg>
  );
}
